<app-breadcrumb></app-breadcrumb>
<div class="container">
     <div class="container-chart">
          <label class="ch-title">{{chartTitle}}</label>
          <div class="chart">
               <p-chart 
               id=pieChart
               type="pie" 
               [data]="chartData" 
               [options]="toggleThemeOptions()"
               width="100%"
               height="300px"
               />
          </div>
          <div class="ch-footer">Tap on a wedge to see the flight time for that slice. Tap on the Legend label to omit that wedge.</div>
          <div class="card">
               <div class="row">
                    @if (timeByVariant && timeByVariant.typeDescription.length > 0) {
                    <div class="column">
                         <div class="label" *ngFor="let item of timeByVariant.typeDescription">
                              <div>{{item}}</div>
                         </div>
                    </div>
                    <div class="column">
                         <div class="data" *ngFor="let item of timeByVariant.time">
                              <div>{{
                                   item | number: '1.1-1'}} hrs</div>
                         </div>
                    </div>
                    }
                    @else {
                    <div class="column">
                         <div class="label">
                              <div>N/A</div>
                         </div>
                    </div>
                    <div class="column">
                         <div class="data">
                              <div>0.0 hrs</div>
                         </div>
                    </div>
                    }
               </div>
          </div>
     </div>
 </div>